
const CtaFinal = () => {
  return (
    <section className="py-24 px-6 lg:px-12 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="bg-gradient-to-br from-emerald-600 to-emerald-800 rounded-3xl p-12 md:p-16 text-center shadow-2xl">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            ¿Listo para Vender tu Coche en Gavá?
          </h2>
          <p className="text-xl text-white/90 mb-10 leading-relaxed max-w-3xl mx-auto">
            Contacta ahora con <strong>Desguace Gavá</strong> y obtén tu valoración gratuita en menos de 2 horas. Sin compromiso, sin letra pequeña. Pago inmediato garantizado.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-5 mb-12">
            <a
              href="tel:+34932932913"
              className="w-full sm:w-auto bg-white text-emerald-700 hover:bg-gray-100 px-10 py-4 rounded-lg font-bold text-lg transition-all hover:scale-105 shadow-xl flex items-center justify-center space-x-3 whitespace-nowrap"
            >
              <i className="ri-phone-fill text-2xl"></i>
              <span>932 932 913</span>
            </a>
            <a
              href="https://wa.me/34932932913?text=Hola,%20quiero%20vender%20mi%20coche%20en%20Gavá"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-full sm:w-auto bg-white text-emerald-700 hover:bg-gray-100 px-10 py-4 rounded-lg font-bold text-lg transition-all hover:scale-105 shadow-xl flex items-center justify-center space-x-3 whitespace-nowrap"
            >
              <i className="ri-whatsapp-fill text-2xl"></i>
              <span>WhatsApp</span>
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-white">
            <div className="flex flex-col items-center">
              <i className="ri-time-fill text-4xl mb-3"></i>
              <p className="font-semibold">Valoración en 2h</p>
            </div>
            <div className="flex flex-col items-center">
              <i className="ri-truck-fill text-4xl mb-3"></i>
              <p className="font-semibold">Recogida Gratuita</p>
            </div>
            <div className="flex flex-col items-center">
              <i className="ri-money-euro-circle-fill text-4xl mb-3"></i>
              <p className="font-semibold">Pago Inmediato</p>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 text-lg">
            Servicio profesional de desguace en <strong>Gavá, Castelldefels, Viladecans</strong> y toda la comarca del Baix Llobregat
          </p>
        </div>
      </div>
    </section>
  );
};

export default CtaFinal;
